import actions from './actions';

const initialState = {
  properties: [],
  activePropertySubscription: null
};

export default function subscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.STORE_PROPERTIES:
      return {
        ...state,
        properties: action.properties,
      };
    case actions.CHANGE_ACTIVE_SUBSCRIPTION:
      return {
        ...state,
        activePropertySubscription: action.activePropertySubscription
      };
    default:
      return state;
  }
}
